export const generateCsvTemplate = (templateId, keys = []) => {
  const allHeaders = ["Target", "Content_Template_Id", ...keys];
  
  const sampleData = [
    "9999999999",                 
    templateId || "YOUR_DLT_ID",  
    ...keys.map(k => `Value_for_${k}`) 
  ];

  const csvContent = [
    allHeaders.join(","),
    sampleData.join(",")
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  
  link.setAttribute("href", url);
  link.setAttribute("download", `TEMPLATE_${templateId || "BULK_UPLOAD"}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const safeJsonParse = (str, key) => {
  try {
    const obj = JSON.parse(str);
    let target = obj[key] || obj;
    if (typeof target === 'string') {
        try { target = JSON.parse(target); } catch(e){}
    }
    return JSON.stringify(target, null, 2);
  } catch(e) { return str; }
};